<template>
  <Container type="card-full">
    <!-- <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn> -->
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">手机号码</div>
          <div class="field">
            <el-input v-model.trim="query.usermobile"  clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">姓名</div>
          <div class="field">
            <el-input v-model.trim="query.username"  clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button @click="search">查询</el-button>
          </div>
        </div>
      </div>
    </div>
    <vggrid :list="list" tableheight="700" flexname="" :cols="cols" :showfooter="false"
            :showPage="true" :resizable="true" :total="query.total" @cellClick="cellClick"
             @cellDblClick="viewProject" @pagechange="pagechange"
        :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick"
    >
        <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
        </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'userIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        btn:{},
        dptList: [],
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'dacname', fieldtype: 'C', title: '所属部门',calculExpr:'', addNewRowFlg: false},
          { field: 'daccount', fieldtype: 'C',title: '授权用户数',calculExpr:'',addNewRowFlg: false},
          // { field: 'username', fieldtype: 'C',title: '创建人',calculExpr:'',addNewRowFlg: false},
          // { field: 'daccreatetime', fieldtype: 'T',title: '创建时间',calculExpr:'',addNewRowFlg: false,formatter: ['toDateString', '']}
        ],
        dac: {},
        query: {
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    created () {
      this.$on('ADD', () => this.addDac())
      this.$on('CHG', () => this.chgDac())
      this.$on('DEL', () => this.delDac())
      // this.$on('CLOSE', () => this.close())
    },
    activated() {
      this.query = {
        total: 0,
        limit: 20,
        offset: 0
      }
      this.getPageList()
    },
    mounted () {
    },
    watch: {
      async '$route' () {
        this.getPageList()
      }
    },
    components: {MenuBtn,vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.dac = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async addDac () {
        let form = {
          userid: this.$store.getters.loginUser.userid,
          dacitems: []
        }
        this.$router.push({name: 'dacForm', params: {form: form, type: 1}})
      },
      async chgDac () {
        this.$router.push({name: 'dacForm', params: {form: this.dac, type: 2}})
      },
      async delDac () {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/xtgl/dac/delDac',
            method: "post",
            data: this.dac
          })
          if (data.issuccess===1) {
            this.getPageList()
            this.$message.success('删除成功！')
          }
        })
      },
      handleSizeChange (btnPage) {
        this.query.offset = btnPage.pageSize * (btnPage.currentPage - 1)
        this.query.limit = btnPage.pageSize
        this.getPageList()
      },
      handleCurrentChange (btnPage) {
        this.query.offset = btnPage.pageSize * (btnPage.currentPage - 1)
        this.query.limit = btnPage.pageSize
        this.getPageList()
      },
      search () {
        this.query.offset = 0
        this.getPageList()
      },
      async save () {
        await request({
          url: '/xtgl/dac/addOrEdit',
          method: "post",
          data: this.dac
        })
        this.$message.success('操作成功')
        if (!this.dac.dacid) {
          this.query.currPage = 1
        }
        await this.getPageList()
      },
      async cellClick (row) {
        this.dac = row.row
      },
      async viewProject(row) {
        this.dac = row.row
        this.$router.push({name: 'dacForm', params: {form: this.dac, type: 3}})
      },
      async pagechange (userPage) {
        this.query.offset = userPage.pageSize * (userPage.currentPage - 1)
        this.query.limit = userPage.pageSize
        this.getPageList()
      },
      search () {
        this.query.offset = 0
        this.getPageList()
      },
      async getPageList () {
        this.loading = true
        this.query.comid = this.$store.getters.loginUser.comid
        let res = await request({
          method: 'get',
          url: '/xtgl/dac/getPageList',
          params: this.query
        })
        console.log(res)
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
